var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { CompanyQueryKey } from './queryKey';
export var useUpdateCompany = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base.put('/api/company/Put', model).then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (!result)
                return;
            queryClient.setQueryData([CompanyQueryKey.Companies], function (old) {
                if (!old)
                    return old;
                return old.map(function (c) { return (c.id === result.id ? __assign(__assign({}, c), result) : c); });
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateCompany: mutateAsync, isUpdating: isLoading };
};
